// extracted by mini-css-extract-plugin
export var root = "G_vJ";
export var wrapper = "G_vK";
export var image = "G_vL d_v d_x d_V";
export var crop = "G_vM";
export var round = "G_vN";
export var fixedHeight = "G_vP";